import { FC } from "react";
import {
  Box,
  Fade,
  Grid,
  LinearProgress,
  Card,
  CardHeader,
  Avatar,
  CardContent,
  Stack,
  styled,
  Paper,
} from "@mui/material";
import { SCUIBreadCrumb, SCUISnackbar } from "../../atomic/molecules";
import { SCUIContent } from "../../atomic/organisms";
import { useTranslation } from "react-i18next";
import { blue } from "@mui/material/colors";
import { BackupTable } from "@mui/icons-material";
import { SCUILiveCampaignFilter } from "./components/SCUILiveCampaignFilter/SCUILiveCampaignFilter";
import { SCUIMatrixTable } from "./components/SCUIMatrixTable/SCUIMatrixTable";
import { CampaignServiceComponent } from "./Campaign.helper";
import { SCUISelectCampaigns } from "./components/SCUISelectCampaigns/SCUISelectCampaigns";
import { useDispatch, useSelector } from "react-redux";
import { hideSnackbar } from "../../stores/redux/actions";


export const CampaignManagementMatrix: FC<any> = (props: any) => {

  const dispatch = useDispatch();
  const snacbarStore = useSelector((state: any) => state.snackbar);

  const {
    loading,
  } = CampaignServiceComponent({ ...props });

  const { t } = useTranslation();

  const FilterActionItem = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    display: "flex",
    alignItems: "center",
  }));

  return (
    <>
      <Box className="campaignLoading">
        <Fade in={loading} unmountOnExit>
          <LinearProgress />
        </Fade>
      </Box>

      <SCUIContent>
        <Grid container direction="row" spacing={2}>
          <SCUIBreadCrumb
            onlyTitle={t("campaignManagement.matrix.title")}
            dontShowHome={true}
          />
        </Grid>

        <Card className="step-form-card">
          <form
            id="MatrixForm"
            name="MatrixForm"
            noValidate={false}
            // onSubmit={stepperOnClickNext}
          >
            <CardHeader
              className="step-form-card-header"
              avatar={
                <Avatar
                  sx={{ bgcolor: blue[50], color: blue["A700"] }}
                  variant="rounded"
                >
                  <BackupTable sx={{ height: 24, width: 24 }} />
                </Avatar>
              }
              title={t("campaignManagement.matrix.title")}
              subheader={""}
            />

            <CardContent className="step-form-card-content">
              <Stack direction="row" spacing={2}>
                <FilterActionItem>
                  <SCUILiveCampaignFilter />
                </FilterActionItem>
                <FilterActionItem>
                  <SCUISelectCampaigns />
                </FilterActionItem>
              </Stack>
              <SCUIMatrixTable />
            </CardContent>
          </form>
        </Card>
        
        <SCUISnackbar
          show={snacbarStore.open}
          messageText={snacbarStore.message}
          status={snacbarStore.status}
          autoHideDuration={snacbarStore.duration}
          onClose={() => {
            dispatch(hideSnackbar());
          }}
        />
      </SCUIContent>
    </>
  );
};